// Port of api/fuel/app/classes/filter/package/games/play/prepare/games/players/group.php
import F from 'offline/filter/constants'
export default {
	require: function(config, filter) { return config.ownerType !== F.OWNER_USER && filter.play && filter.play.group },
	run: function(local, global) {
		local.players = {}
		local.record = { results: 0 }
		var plays = (global.players && global.players[local.game_id]) ? global.players[local.game_id] : []

		for (var i = 0; i < plays.length; i++) {
			var play = plays[i]
			var userId = parseInt(play.u, 10) || 0

			if (!local.players[userId]) {
				local.players[userId] = {
					id: userId,
					results: 0,
					wins: 0
				}
			}

			var playCount = parseInt(play.co, 10) || 0
			local.players[userId].results += playCount
			local.record.results += playCount

			if (play.pr) {
				var configData = global.playerConfig && global.playerConfig[userId]
				var usernames = configData && configData.plays && configData.plays.usernames ? configData.plays.usernames : []

				if ((parseInt(play.wu, 10) || 0) === userId || usernames.indexOf(play.wn) !== -1) {
					local.players[userId].wins += playCount
				}
			}
		}

		return local
	}
}
